import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "text-left" }
const _hoisted_2 = {
  key: 0,
  class: "text-body-2 text-medium-emphasis my-4 text-center"
}
const _hoisted_3 = {
  key: 2,
  class: "text-body-2 text-medium-emphasis text-center my-4"
}
const _hoisted_4 = {
  key: 4,
  class: "text-center mt-2"
}

import { computed, ref, watch } from "vue";
import {
  ViewPartidaAmistosaDTO,
  ViewPartidaTorneoDTO,
} from "@/interfaces/Partidas";
import { nombreEvento } from "@/Constant/FormatoTorneo";
import {
  balanceDe,
  cumpleFiltro,
  FiltroPartidas,
  PartidaJugada,
  ResultadoPartida,
} from "@/utils/historialJugador";
import BarraBalance from "@/components/DetalleJugador/BarraBalance.vue";
import CardPartidaTorneo from "@/components/PartidasTorneo/CardPartidaTorneo.vue";
import ValidadasMatchCard from "@/components/PartidaAmistosa/ValidadasMatchCard.vue";

// Las partidas jugadas de un jugador, de eventos o amistosas, con su balance, filtros y buscador
const TANDA = 12;

export default /*#__PURE__*/_defineComponent({
  __name: 'PartidasJugador',
  props: {
    partidas: {},
    origen: {},
    idUsuario: {},
    filtro: {}
  },
  emits: ["update:filtro"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const RESULTADOS: { valor: ResultadoPartida | "todas"; titulo: string }[] = [
  { valor: "todas", titulo: "Todas" },
  { valor: "V", titulo: "Victorias" },
  { valor: "E", titulo: "Empates" },
  { valor: "D", titulo: "Derrotas" },
];

const filtroResultado = ref<ResultadoPartida | "todas">("todas");
const filtroFormato = ref<string>("todos");
const busqueda = ref<string | null>("");
const cuantasVer = ref(TANDA);

const propias = computed(() => props.partidas.filter(p => p.origen === props.origen));

// Torneo, Liga o Copa: el filtro solo sale si ha jugado más de uno
const formatoDe = (p: PartidaJugada) => nombreEvento(p.formato);
const formatos = computed(() =>
  props.origen === "torneo" ? [...new Set(propias.value.map(formatoDe))] : []
);
const plural = (nombre: string) => (nombre === "Torneo" ? "Torneos" : `${nombre}s`);

const normalizar = (texto: string) =>
  texto.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();

// Todos los filtros menos el de resultado: así cada pastilla dice cuántas tiene
const sinResultado = computed(() => {
  const texto = normalizar(busqueda.value ?? "").trim();
  return propias.value.filter(
    p =>
      cumpleFiltro(p, props.filtro) &&
      (filtroFormato.value === "todos" || formatoDe(p) === filtroFormato.value) &&
      (!texto ||
        normalizar(p.nickRival).includes(texto) ||
        normalizar(p.evento ?? "").includes(texto))
  );
});
const cuantos = (valor: ResultadoPartida | "todas") =>
  valor === "todas"
    ? sinResultado.value.length
    : sinResultado.value.filter(p => p.resultado === valor).length;

const filtradas = computed(() =>
  filtroResultado.value === "todas"
    ? sinResultado.value
    : sinResultado.value.filter(p => p.resultado === filtroResultado.value)
);
const visibles = computed(() => filtradas.value.slice(0, cuantasVer.value));
const balance = computed(() => balanceDe(sinResultado.value));
// Con un rival pulsado, el balance es el cara a cara con él
const titulo = computed(() =>
  props.filtro?.nickRival
    ? `Contra ${props.filtro.nickRival}`
    : props.filtro?.ejercito
      ? `Con ${props.filtro.ejercito}`
      : props.origen === "torneo"
        ? "En eventos"
        : "En amistosas"
);

// Al cambiar un filtro se vuelve a la primera tanda; al pasar a otro jugador, todo de cero
watch([filtroResultado, filtroFormato, busqueda, () => props.filtro], () => {
  cuantasVer.value = TANDA;
});
watch(
  () => props.idUsuario,
  () => {
    filtroResultado.value = "todas";
    filtroFormato.value = "todos";
    busqueda.value = "";
    cuantasVer.value = TANDA;
  }
);

return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_chip_group = _resolveComponent("v-chip-group")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (propias.value.length === 0)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.origen === "torneo" ? "Aún no tiene partidas de eventos." : "Aún no tiene partidas amistosas."), 1))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.filtro?.ejercito || _ctx.filtro?.nickRival)
            ? (_openBlock(), _createBlock(_component_v_chip, {
                key: 0,
                color: "primary",
                variant: "flat",
                size: "small",
                closable: "",
                "prepend-icon": _ctx.filtro.nickRival ? 'mdi-account' : 'mdi-shield',
                class: "mb-2",
                "onClick:close": _cache[0] || (_cache[0] = ($event: any) => (emit('update:filtro', null)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.filtro.nickRival ? `Contra ${_ctx.filtro.nickRival}` : `Con ${_ctx.filtro.ejercito}`), 1)
                ]),
                _: 1
              }, 8, ["prepend-icon"]))
            : _createCommentVNode("", true),
          _createVNode(_component_v_card, {
            class: "pa-3 mb-3",
            variant: "outlined"
          }, {
            default: _withCtx(() => [
              _createVNode(BarraBalance, {
                titulo: titulo.value,
                balance: balance.value
              }, null, 8, ["titulo", "balance"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_chip_group, {
            modelValue: filtroResultado.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filtroResultado).value = $event)),
            mandatory: "",
            column: "",
            "selected-class": "text-primary"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(RESULTADOS, (r) => {
                return _createVNode(_component_v_chip, {
                  key: r.valor,
                  value: r.valor,
                  size: "small",
                  filter: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(r.titulo) + " (" + _toDisplayString(cuantos(r.valor)) + ") ", 1)
                  ]),
                  _: 2
                }, 1032, ["value"])
              }), 64))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          (formatos.value.length > 1)
            ? (_openBlock(), _createBlock(_component_v_chip_group, {
                key: 1,
                modelValue: filtroFormato.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filtroFormato).value = $event)),
                mandatory: "",
                column: "",
                "selected-class": "text-primary"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_chip, {
                    value: "todos",
                    size: "small",
                    filter: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Todos")
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formatos.value, (f) => {
                    return (_openBlock(), _createBlock(_component_v_chip, {
                      key: f,
                      value: f,
                      size: "small",
                      filter: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(plural(f)), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          _createVNode(_component_v_text_field, {
            modelValue: busqueda.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((busqueda).value = $event)),
            label: _ctx.origen === 'torneo' ? 'Buscar rival o evento' : 'Buscar rival',
            "prepend-inner-icon": "mdi-magnify",
            density: "compact",
            clearable: "",
            "hide-details": "",
            class: "mt-1 mb-3"
          }, null, 8, ["modelValue", "label"]),
          (filtradas.value.length === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, " No hay partidas con estos filtros. "))
            : (_openBlock(), _createBlock(_component_v_row, {
                key: 3,
                dense: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibles.value, (partida) => {
                    return (_openBlock(), _createBlock(_component_v_col, {
                      key: partida.clave,
                      cols: "12",
                      sm: "6",
                      lg: "4"
                    }, {
                      default: _withCtx(() => [
                        (partida.origen === 'torneo')
                          ? (_openBlock(), _createBlock(CardPartidaTorneo, {
                              key: 0,
                              idUsuario: _ctx.idUsuario,
                              match: (partida.original as ViewPartidaTorneoDTO)
                            }, null, 8, ["idUsuario", "match"]))
                          : (_openBlock(), _createBlock(ValidadasMatchCard, {
                              key: 1,
                              idUsuario: _ctx.idUsuario,
                              match: (partida.original as ViewPartidaAmistosaDTO)
                            }, null, 8, ["idUsuario", "match"]))
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })),
          (filtradas.value.length > visibles.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_v_btn, {
                  variant: "tonal",
                  size: "small",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (cuantasVer.value += TANDA))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Ver más (" + _toDisplayString(filtradas.value.length - visibles.value.length) + ") ", 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ], 64))
  ]))
}
}

})